// // import { Button, Form, notification, Tabs } from "antd";
// // import { useForm } from "antd/es/form/Form";
// // import { useEffect, useState } from "react";
// // import { useSelector } from "react-redux";
// // import { useNavigate } from "react-router-dom";
// // import PageHeaders from "../../components/pageHeaders";
// // import { API } from "../../config/Api";
// // import { GET, POST, PUT } from "../../utils/apiRequest";
// // import SubscriptionDataTable from "./dataTable";
// // import LoadingBox from "../../components/loadingBox";
// // import TokenDataTable from "./token/dataTable";

// // function SubscriptionScreen() {
// //   const navigate = useNavigate();
// //   const [form] = useForm();
// //   const [Notifications, contextHolder] = notification.useNotification();
// //   const User = useSelector((state: any) => state?.User?.user);
// //   const [data, setData] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [page, setPage] = useState<number>(1);
// //   const [meta, setMeta] = useState<any>();
// //   const [pageSize, setPageSize] = useState<any>(10);
// //   const [activeTab, setActiveTab] = useState("Subscription");

// //   useEffect(() => {
// //     if (activeTab === "Subscription") {
// //       getSubscriptionAll();
// //     }else{
// //       getTokens()

// //     }
// //   }, [activeTab, page, pageSize]);

// //   const handlePageChange = (page: number, take: number) => {
// //     setPage(page);
// //     setPageSize(take);
// //   };

// //   const getSubscriptionAll = async () => {
// //     try {
// //       let api = `${API.SUBCRIPTION_ALL}${User?.office?.id}`;
// //       const response: any = await GET(api, null);
// //       if (response?.status) {
// //         setData(response?.data);
// //         setMeta(response?.meta);
// //       }
// //       setLoading(false);
// //     } catch (error) {
// //       setLoading(false);
// //       console.error(error);
// //     }
// //   };

// //   const deleteSub = async (id: number) => {
// //     try {
// //       setLoading(true);
// //       let api = `${API.SUBCRIPTION_DELETE_SOFT}${id}`;
// //       const del: any = await PUT(api, {});
// //       if (del?.status) {
// //         getSubscriptionAll();
// //       }
// //       setLoading(false);
// //     } catch (err) {
// //       setLoading(false);
// //       console.log(err);
// //     }
// //   };

// //   const getTokens = async () => {
// //     try {
// //       let api = `${API.LIST_TOKEN}?order=DESC&page=${1}&take=20`;
// //       let payload = {office_id: User?.office?.id, is_token: true};
// //       const response: any = await POST(api, payload);
// //       if (response?.status) {
// //         if (response?.meta?.currentPage === 1) {
// //           // setTokens(response.data || []);
// //         } else {
// //           // setTokens((prev: any) => [...prev, ...(response.data || [])]);
// //         }
// //         // setMeta({
// //         //   hasNextPage: response.meta?.hasNextPage || false,
// //         //   pageCount: response.meta?.pageCount || 0,
// //         //   currentPage: pageNum,
// //         //   itemCount: response.meta?.itemCount || 0,
// //         // });
// //       } else {
// //         console.log(response?.message);
// //       }
// //     } catch (error) {
// //       console.error(error);
// //     } finally {
// //       // setIsLoading(false);
// //       // setloadingMore(false);
// //     }
// //   };

// //   useEffect(() => {
// //   }, [])
// //   ;

// //   const onChange = (key: string) => {
// //     setActiveTab(key)
// //   };

// //   const items: any['items'] = [
// //     {
// //       key: '1',
// //       label: 'Subscription',
// //       children: <>

// //       {loading ? <LoadingBox /> : (
// //         <SubscriptionDataTable
// //           data={data}
// //           page={page || 1}
// //           current={page || 1}
// //           pageSize={pageSize}
// //           onPageChange={handlePageChange}
// //           total={meta?.itemCount || 0}
// //           delete={(id: number) => deleteSub(id)}
// //         />
// //       )},
// //             </>

// //     },
// //     {
// //       key: '2',
// //       label: 'Token',
// //       children: <TokenDataTable/>,
// //     },

// //   ];

// //   return (
// //     <div>
// //       {contextHolder}
// //       <PageHeaders title={"Subscription"} breadcrumb="Subscription">
// //         <Form form={form}>
// //           <div className="d-flex flex-column flex-wrap flex-sm-row gap-2">
// //             <Form.Item noStyle>
// //               <Button onClick={() => navigate(`/Auth/createSubscription`)} type="primary">
// //                 Create +
// //               </Button>
// //             </Form.Item>
// //           </div>
// //         </Form>
// //       </PageHeaders>

// //       <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
// //           {/* {loading ? <LoadingBox /> : (
// //             <SubscriptionDataTable
// //               data={data}
// //               page={page || 1}
// //               current={page || 1}
// //               pageSize={pageSize}
// //               onPageChange={handlePageChange}
// //               total={meta?.itemCount || 0}
// //               delete={(id: number) => deleteSub(id)}
// //             />
// //           )} */}

// //     </div>
// //   );
// // }

// // export default SubscriptionScreen;

// // SubscriptionScreen.tsx
// import { Button, Form, notification, Tabs } from "antd";
// import { useForm } from "antd/es/form/Form";
// import { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import PageHeaders from "../../components/pageHeaders";
// import { API } from "../../config/Api";
// import { GET, POST, PUT } from "../../utils/apiRequest";
// import SubscriptionDataTable from "./dataTable";
// import LoadingBox from "../../components/loadingBox";
// import TokenDataTable from "./token/dataTable";

// function SubscriptionScreen() {
//   const navigate = useNavigate();
//   const [form] = useForm();
//   const [Notifications, contextHolder] = notification.useNotification();
//   const User = useSelector((state: any) => state?.User?.user);
//   const [data, setData] = useState([]);
//   const [tokenData, setTokenData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [tokenLoading, setTokenLoading] = useState(true);
//   const [page, setPage] = useState<number>(1);
//   const [tokenPage, setTokenPage] = useState<number>(1);
//   const [meta, setMeta] = useState<any>();
//   const [tokenMeta, setTokenMeta] = useState<any>();
//   const [pageSize, setPageSize] = useState<number>(10);
//   const [tokenPageSize, setTokenPageSize] = useState<number>(10);
//   const [activeTab, setActiveTab] = useState("1");

//   useEffect(() => {
//     if (activeTab === "1") {
//       getSubscriptionAll();
//     } else {
//       getTokens();
//     }
//   }, [activeTab, page, pageSize, tokenPage, tokenPageSize]);

//   const handlePageChange = (page: number, take: number) => {
//     setPage(page);
//     setPageSize(take);
//   };

//   const handleTokenPageChange = (page: number, take: number) => {
//     setTokenPage(page);
//     setTokenPageSize(take);
//   };

//   // const getSubscriptionAll = async () => {
//   //   try {
//   //     let api = `${API.list_office_Subs}${User?.office?.id}`;
//   //     const response: any = await GET(api, null);
//   //     if (response?.status) {
//   //       setData(response?.data);
//   //       setMeta(response?.meta);
//   //     }
//   //     setLoading(false);
//   //   } catch (error) {
//   //     setLoading(false);
//   //     console.error(error);
//   //   }
//   // };

//   const getSubscriptionAll = async () => {
//     try {
//       const page = 2; // You can set the page dynamically based on user input or state
//       const take = 10; // Similarly, set 'take' dynamically if needed
//       const order = "ASC"; // You can adjust this value as needed
//       let api = `${API.list_office_Subs}${User?.office?.id}?order=${order}&page=${page}&take=${take}`;

//       const response: any = await GET(api, null);
//       if (response?.status) {
//         setData(response?.data);
//         setMeta(response?.meta);
//       }
//       setLoading(false);
//     } catch (error) {
//       setLoading(false);
//       console.error(error);
//     }
//   };

//   const getTokens = async () => {
//     try {
//       setTokenLoading(true);
//       let api = `${API.LIST_TOKEN}?order=DESC&page=${tokenPage}&take=${tokenPageSize}`;
//       let payload = { office_id: User?.office?.id, is_token: true };
//       const response: any = await POST(api, payload);
//       if (response?.status) {
//         setTokenData(response.data || []);
//         setTokenMeta({
//           hasNextPage: response.meta?.hasNextPage || false,
//           pageCount: response.meta?.pageCount || 0,
//           currentPage: response.meta?.page || 1,
//           itemCount: response.meta?.itemCount || 0,
//         });
//       } else {
//         console.log(response?.message);
//       }
//     } catch (error) {
//       console.error(error);
//     } finally {
//       setTokenLoading(false);
//     }
//   };

//   const deleteSub = async (id: number) => {
//     try {
//       setLoading(true);
//       let api = `${API.SUBCRIPTION_DELETE_SOFT}${id}`;
//       const del: any = await PUT(api, {});
//       if (del?.status) {
//         getSubscriptionAll();
//       }
//       setLoading(false);
//     } catch (err) {
//       setLoading(false);
//       console.log(err);
//     }
//   };

//   const deleteToken = async (id: number) => {
//     try {
//       setTokenLoading(true);
//       let api = ``;
//       const del: any = await PUT(api, {});
//       if (del?.status) {
//         getTokens();
//       }
//       setTokenLoading(false);
//     } catch (err) {
//       setTokenLoading(false);
//       console.log(err);
//     }
//   };

//   const onChange = (key: string) => {
//     setActiveTab(key);
//   };

//   const items = [
//     {
//       key: "1",
//       label: "Subscription",
//       children: (
//         <>
//           {loading ? (
//             <LoadingBox />
//           ) : (
//             <SubscriptionDataTable
//               data={data}
//               page={page}
//               current={page}
//               pageSize={pageSize}
//               onPageChange={handlePageChange}
//               total={meta?.itemCount || 0}
//               delete={deleteSub}
//             />
//           )}
//         </>
//       ),
//     },
//     {
//       key: "2",
//       label: "Token",
//       children: (
//         <>
//           {tokenLoading ? (
//             <LoadingBox />
//           ) : (
//             <TokenDataTable
//               data={tokenData}
//               page={tokenPage}
//               current={tokenPage}
//               pageSize={tokenPageSize}
//               onPageChange={handleTokenPageChange}
//               total={tokenMeta?.itemCount || 0}
//               delete={deleteToken}
//             />
//           )}
//         </>
//       ),
//     },
//   ];

//   return (
//     <div>
//       {contextHolder}
//       <PageHeaders title={"Subscription"} breadcrumb="Subscription">
//         <Form form={form}>
//           <div className="d-flex flex-column flex-wrap flex-sm-row gap-2">
//             <Form.Item noStyle>
//               <Button
//                 onClick={() => navigate(`/Auth/createSubscription`)}
//                 type="primary"
//               >
//                 Create +
//               </Button>
//             </Form.Item>
//           </div>
//         </Form>
//       </PageHeaders>

//       <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
//     </div>
//   );
// }

// export default SubscriptionScreen;

import { Button, Form, notification, Tabs } from "antd";
import { useForm } from "antd/es/form/Form";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PageHeaders from "../../components/pageHeaders";
import { API } from "../../config/Api";
import { GET, POST, PUT } from "../../utils/apiRequest";
import SubscriptionDataTable from "./dataTable";
import LoadingBox from "../../components/loadingBox";
import TokenDataTable from "./token/dataTable";

function SubscriptionScreen() {
  const navigate = useNavigate();
  const [form] = useForm();
  const [Notifications, contextHolder] = notification.useNotification();
  const User = useSelector((state: any) => state?.User?.user);
  const [data, setData] = useState([]);
  const [tokenData, setTokenData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tokenLoading, setTokenLoading] = useState(true);
  const [page, setPage] = useState<number>(1);
  const [tokenPage, setTokenPage] = useState<number>(1);
  const [meta, setMeta] = useState<any>();
  const [tokenMeta, setTokenMeta] = useState<any>();
  const [pageSize, setPageSize] = useState<number>(10);
  const [tokenPageSize, setTokenPageSize] = useState<number>(10);
  const [activeTab, setActiveTab] = useState("1");

  useEffect(() => {
    if (activeTab === "1") {
      getSubscriptionAll();
    } else {
      getTokens();
    }
  }, [activeTab, page, pageSize, tokenPage, tokenPageSize]);

  const handlePageChange = (page: number, take: number) => {
    setPage(page);
    setPageSize(take);
  };

  const handleTokenPageChange = (page: number, take: number) => {
    setTokenPage(page);
    setTokenPageSize(take);
  };

  const getSubscriptionAll = async () => {
    try {
      const order = "DESC";
      let api = `${API.list_office_Subs}${User?.office?.id}?order=${order}&page=${page}&take=${pageSize}`;

      const response: any = await GET(api, null);
      if (response?.status) {
        setData(response?.data);
        setMeta(response?.meta);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const getTokens = async () => {
    try {
      setTokenLoading(true);
      let api = `${API.LIST_TOKEN}?order=DESC&page=${tokenPage}&take=${tokenPageSize}`;
      let payload = { office_id: User?.office?.id, is_token: true };
      const response: any = await POST(api, payload);
      if (response?.status) {
        setTokenData(response.data || []);
        setTokenMeta({
          hasNextPage: response.meta?.hasNextPage || false,
          pageCount: response.meta?.pageCount || 0,
          currentPage: response.meta?.page || 1,
          itemCount: response.meta?.itemCount || 0,
        });
      } else {
        console.log(response?.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setTokenLoading(false);
    }
  };

  const deleteSub = async (id: number) => {
    try {
      setLoading(true);
      let api = `${API.SUBCRIPTION_DELETE_SOFT}${id}`;
      const del: any = await PUT(api, {});
      if (del?.status) {
        getSubscriptionAll();
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };

  const deleteToken = async (id: number) => {
    try {
      setTokenLoading(true);
      let api = "";
      const del: any = await PUT(api, {});
      if (del?.status) {
        getTokens();
      }
      setTokenLoading(false);
    } catch (err) {
      setTokenLoading(false);
      console.log(err);
    }
  };

  const onChange = (key: string) => {
    setActiveTab(key);
  };

  const items = [
    {
      key: "1",
      label: "Subscription",
      children: (
        <>
          {loading ? (
            <LoadingBox />
          ) : (
            <SubscriptionDataTable
              data={data}
              page={page}
              current={page}
              pageSize={pageSize}
              onPageChange={handlePageChange}
              total={meta?.itemCount || 0}
              delete={deleteSub}
            />
          )}
        </>
      ),
    },
    {
      key: "2",
      label: "Token",
      children: (
        <>
          {tokenLoading ? (
            <LoadingBox />
          ) : (
            <TokenDataTable
              data={tokenData}
              page={tokenPage}
              current={tokenPage}
              pageSize={tokenPageSize}
              onPageChange={handleTokenPageChange}
              total={tokenMeta?.itemCount || 0}
              delete={deleteToken}
            />
          )}
        </>
      ),
    },
  ];

  return (
    <div>
      {contextHolder}
      <PageHeaders
        title={`${activeTab === "1" ? "Subscription" : "Token"}`}
        breadcrumb={`${activeTab === "1" ? "Subscription" : "Token"}`}
      >
        <Form form={form}>
          <div className="d-flex flex-column flex-wrap flex-sm-row gap-2">
            <Form.Item noStyle>
              <Button
                onClick={() => navigate(`/Auth/createSubscription`)}
                type="primary"
              >
                Create +
              </Button>
            </Form.Item>
          </div>
        </Form>
      </PageHeaders>

      <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
    </div>
  );
}

export default SubscriptionScreen;
